export const TeamRouting = [
    {
      path: "/maintenance/team/list",
      name: "maintenance-team-list",
      meta: { title: "维保项目团队" },
      component: () =>
        import(
          /* webpackChunkName: "project-profile" */ "@/views/maintenance/team/list/index.vue"),
    }
    
  ];
  